import React, { useEffect, useState } from "react";
import { Box, Spinner, Heading, Text, Header } from "grommet";
import { HeaderNavigation } from "../components/Headers/GlobalHeader";
import { StickyFooter } from "../components/Footers/GlobalFooter";
import { LoginForm } from "../components/Login/LoginForm";
import axios from "axios";
import { Alert } from "grommet-icons";

const LoginPage = () => {
  const [loading, setLoading] = useState(true);
  const [showMaintenanceMessage, setShowMaintenanceMessage] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    // Fetch maintenance data from the API
    axios
      .get("/api/dashboard/active-maintenance-actions")
      .then((response) => {
        const data = response.data.maintenanceActions[0]; // Assuming the first action is the one we want
        setData(data);
        if (
          data &&
          data.startDate &&
          data.startTime &&
          data.endDate &&
          data.endTime
        ) {
          setShowMaintenanceMessage(true);
        }
      })
      .catch(() => {/* non-critical — maintenance banner simply won't show */})
      .finally(() => setLoading(false));
  }, []);


  return (
    <Box fill="vertical" justify="between" style={{ position: "relative" }}>
      {/* Main content container */}
      <Box flex="grow">
        <HeaderNavigation quizStarted={true} />
        {showMaintenanceMessage && (
          <Box
            pad="medium"
            border={{ color: "status-warning", size: "small" }}
            background={{ color: "status-warning", opacity: "weak" }}
            round="xsmall"
            width="auto"
            margin={{ horizontal: "large", top: "medium" }}
            direction="row" // Align icon and text in a row
            gap="small" // Add spacing between the icon and text
            align="center" // Vertically align the icon and text
          >
            <Alert color="status-warning" /> {/* Add the Alert icon */}
            <Text color="status-warning" size="small" textAlign="center">
              The HPE Digital Skill Advisor is currently undergoing scheduled
              maintenance from{" "}
              <strong>
                {data.startDate} {data.startTime}
              </strong>{" "}
              to{" "}
              <strong>
                {data.endDate} {data.endTime}
              </strong>{" "}
              UTC. During this period, you may experience temporary
              unavailability of services. We appreciate your understanding and
              patience while we work to improve the platform.
            </Text>
          </Box>
        )}
        {/* Main content with heading and login form */}
        <Box
          direction="row"
          justify="between"
          align="center"
          margin={{ horizontal: "large" }}
          pad={{ horizontal: "large" }}
          fill="vertical"
          height={{ min: "medium" }}
        >
          {/* Left side with heading and text */}
          <Box basis="1/2" pad={{ right: "medium" }} align="start">
            <Header
              direction="column"
              align="start"
              gap="small"
              pad={{ horizontal: "xxsmall" }}
            >
              <Heading level="2" margin="none">
                Welcome to the HPE Digital Skill Advisor.
              </Heading>
              <Text size="medium">
                The HPE Digital Skill Advisor is an online resource designed to
                help individuals swiftly pinpoint the skills needed to boost
                their technical expertise, gain insight into transformative
                technologies, and enhance for
                career growth and better business outcomes. By assessing the
                information you share about your unique needs, it dynamically
                presents personalized learning paths and training options that
                align with your preferred learning style.
              </Text>
            </Header>
          </Box>

          {/* Right side with login form */}
          <Box basis="1/2" align="end" pad={{ left: "medium" }}>
            <LoginForm setLoading={setLoading} />
          </Box>
        </Box>
      </Box>
      <StickyFooter />

      {/* Full-screen overlay when loading */}
      {loading && (
        <Box
          fill
          align="center"
          justify="center"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 10,
            backgroundColor: "white",
          }}
        >
          <Spinner />
          <Text>Redirecting...</Text>
        </Box>
      )}
    </Box>
  );
};

export default LoginPage;
